import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app';
import isLocalStorageAvailable from './components/app/localStorageAvailable';
import CookiesAlert from './components/alert/cookiesAlert';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element not found');
}

const cookiesEnabled = isLocalStorageAvailable();

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>{cookiesEnabled ? <App /> : <CookiesAlert />}</React.StrictMode>,
);
